import { Building2 } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const onboardingManifest: ModuleDefinition = {
  id: 'onboarding',
  name: 'Onboarding',
  icon: <Building2 size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/onboarding',
  status: 'active',
  navItems: [],
  component: () => import('./index.js'),
};

export default onboardingManifest;
